// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"ce324e4e","134":"924080cc","198":"035c599f","411":"25b2c317","474":"515185ba","649":"e4a90c5a","832":"9a9d0700","887":"84a40bf2","951":"3e8f12c2","965":"807a61ef"}[chunkId] + ".chunk.js";
};